/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGalleryDto } from '../../models/create-gallery-dto';
import { GalleryDto } from '../../models/gallery-dto';

export interface GalleryControllerCreateV1$Params {
      body: CreateGalleryDto
}

export function galleryControllerCreateV1(http: HttpClient, rootUrl: string, params: GalleryControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryDto>> {
  const rb = new RequestBuilder(rootUrl, galleryControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GalleryDto>;
    })
  );
}

galleryControllerCreateV1.PATH = '/api/v1/gallery';
